export const getCenterCoordinates = () => {
  const center: any = {
    lat: 36.131342,
    lng: 139.6015
  }
  return center
}
